import { getLocaleCurrencyCode, getCurrencySymbol } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { EmailPhoneValues, SummarySectionElements } from 'src/app/interfaces/form-model';
import { CurrencyService } from 'src/app/service/currency.service';

@Component({
  selector: 'app-summary-simple-text',
  templateUrl: './summary-simple-text.component.html',
  styleUrls: ['./summary-simple-text.component.scss']
})
export class SummarySimpleTextComponent {

  @Input() element!: SummarySectionElements;

  constructor(
    private currencyService: CurrencyService,
    @Inject(LOCALE_ID) private locale: string
  ) { }

  getLabel() {
    return this.element.label;
  }

  getLabelForSpecificFields(value: EmailPhoneValues) {
    return this.getCustomLabel(value);
  }

  getText() {

    switch (this.element.type) {
      case 120:
        return this.getDisplayName();
      case 170:
      case 1340:
        return this.getCompanyName();
      case 336:
        return this.getName();
      case 130:
      case 348:
        return this.getFullName();
      case 3:
      case 202:
        return this.getDateValue();
      default:
        return this.element.value;
    }
  }

  getTextForSpecificFields(value: EmailPhoneValues) {
    return value.email || value.phone;
  }

  getDateValue() {
    return this.element.value;
  }

  getName(): string {
    return `${this.element.firstName} ${this.element.lastName}`;
  }

  getFullName() {
    const prefix = this.element.prefixes.find((selection: any) => selection.selected)?.name;
    const suffix = this.element.suffixes.find((selection: any) => selection.selected)?.name;

    // Collect all parts of the name and filter out undefined or empty values
    const nameParts = [
      prefix,
      this.element.firstName,
      this.element.middleName,
      this.element.lastName,
      suffix,
    ].filter(Boolean); // Remove undefined, null, or empty strings

    return nameParts.join(' '); // Join the remaining parts with a space
  }

  getCustomLabel(value: EmailPhoneValues) {

    if (value.typeLabel.name !== '') {
      return `${this.element.label} - ${value.typeLabel.name}`;
    } else {
      return `${this.element.label}`;
    }
  }

  getPhone(value: EmailPhoneValues) {
    return value.phone;
  }

  getEmail(value: EmailPhoneValues) {
    return value.email;
  }

  getDisplayName() {
    return this.element.displayName;
  }

  getCompanyName() {
    return this.element.companyName;
  }

  getTextFromNumberWithCurrency() {
    return this.currencyService.formatCurrency(parseFloat(this.element.value));
  }

  getCurrencySymbol() {
    const currencyCode = getLocaleCurrencyCode(this.locale) || "en";
    return getCurrencySymbol(currencyCode, "narrow", this.locale);
  }

  get emailPhoneValues(): EmailPhoneValues[] {
    return Array.isArray(this.element.values) ? this.element.values as EmailPhoneValues[] : [];
  }
}
